import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { ISetExistingAddonsAction } from "../../../Orchestrator/Types/Interface/IAddOns";

export class SetExistingAddonsAction extends BaseAction<
  IDefaultActionResult,
  ISetExistingAddonsAction
> {
  override async run(): Promise<IDefaultActionResult | null> {
    const actionResult: IDefaultActionResult = {
      data: null,
      message: "",
      status: "fail",
    };
    try {
      let { existing, addonsPassengerList } = this.params!;

      const updateAddons = addonsPassengerList.map((pass) => {
        if (pass.legId === existing.legId)
          return {
            ...existing,
            addonsPassenger: existing.addonsPassenger.map((d, index) =>
              index === 0 ? { ...d, isActive: true } : { ...d, isActive: false }
            ),
          };
        else return pass;
      });
      
      updateRecoilState("addonsPassengerListAtom", updateAddons);

      actionResult.status = "success";
    } catch (error: any) {
      console.log("error", error);
      actionResult.message = error.message;
    } finally {
      return actionResult;
    }
  }
}

export const setExistingAddonsAction = new SetExistingAddonsAction();
